
function hasSusbcribeCookie () {
  if (localStorage.getItem('data')) {
    const data = JSON.parse(localStorage.getItem('data'))
    return !!data.hasSubcribed
  }
  return false
}

function setSubscribeCookie () {
  const popup = JSON.stringify({hasSubcribed: true})
  localStorage.setItem('data', popup)
}

function trackEvent (event) {
  window.analytics.track(event)
}

export {
  setSubscribeCookie, hasSusbcribeCookie, trackEvent
}



// WEBPACK FOOTER //
// ./src/mixins/storageMixin.js